interface ComparisonRow {
  feature: string;
  litbuy: string;
  alternative: string;
}

interface ComparisonTableProps {
  rows: ComparisonRow[];
}

export default function ComparisonTable({ rows }: ComparisonTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b-2 border-background-200">
            <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-900">Feature</th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-primary-700">Litbuy Spreadsheet</th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-600">Alternative Method</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={index}
              className={`border-b border-background-200/70 transition-colors duration-150 hover:bg-background-100/50 ${
                index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/30'
              }`}
            >
              <td className="py-3.5 px-4 text-sm font-medium text-foreground-800">{row.feature}</td>
              <td className="py-3.5 px-4 text-sm text-foreground-700">{row.litbuy}</td>
              <td className="py-3.5 px-4 text-sm text-foreground-500">{row.alternative}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}